import KnownOriginResult from "../../../domains/Origins/KnownOriginResult";

import {
  getOriginStatus,
  getOriginStatusSuccess,
  getOriginStatusError
} from "./actions";

import originsReducer from "./reducer";

export interface OriginsState {
  isFetchingOrigin: boolean
  hasError: boolean
  originStatus: Array<KnownOriginResult>
}

export const initialState: OriginsState = {
  isFetchingOrigin: false,
  hasError: false,
  originStatus: [],
};

export { getOriginStatus, getOriginStatusSuccess, getOriginStatusError };

export default originsReducer;
